module.exports = __webpack_public_path__ + "img/help.bb79a553.png";